<template>
    <div class="additionalCosts" v-if="loading || !disabled || costs.length > 0">
        <div class="title green" v-if="'customer' === type">{{ __('Additional Costs to the Customer') }}</div>
        <div class="title red" v-else-if="'dax' === type">{{ __('Additional Costs to DAX Automation') }}</div>
        <div class="title black" v-else-if="'deposits' === type">{{ __('Customer Deposits') }}</div>
        <div class="title" v-else>{{ __('Unknown type') }}</div>

        <enq-additional-cost
            v-if="!disabled"
            :class="costs.length > 0 ? 'mt-2' : 'my-2'"
            :currencies="currencies"
            :reasons="reasons"
            :initial-currency-id="defaultCurrencyId"
            :disabled="disabledOrNoPerm"
            :currency-selectable="currencySelectable"
            :reason-selectable="reasonSelectable"
            :create="true"
            :on-submit="onSubmit"
            :on-updated="onUpdated"
            :on-deleted="onDeleted"
            ref="create"
        ></enq-additional-cost>

        <div v-if="costs.length > 0 || loading">
            <hr class="my-2" v-if="!disabled">

            <div
                v-if="loading"
                class="mb-2 mx-4 d-flex align-items-center"
                :class="disabled ? 'mt-2' : ''"
            >
                <strong>{{ __('Loading...') }}</strong>
                <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
            </div>

            <enq-additional-cost
                v-else
                v-for="(cost, key) in costs"
                :key="cost.ID + ':' + (cost.reloadID || 0)"
                :index="key"
                class="mb-2"
                :class="disabled && 0 === key ? 'mt-2' : ''"
                :currencies="currencies"
                :reasons="reasons"
                :initial-currency-id="currencySelectable ? cost.currencyID : defaultCurrencyId"
                :initial-value="cost.value"
                :initial-reason-id="cost.reasonID"
                :disabled="disabledOrNoPerm"
                :currency-selectable="currencySelectable && existingReasonSelectable"
                :reason-selectable="reasonSelectable && existingReasonSelectable"
                :create="false"
                :on-submit="onSubmit"
                :on-updated="onUpdated"
                :on-deleted="onDeleted"
            ></enq-additional-cost>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqPortionAdditionalCosts",

    props: {
        currencies: {
            required: true,
            type: Array
        },

        reasons: {
            required: true,
            type: Array
        },

        defaultCurrencyId: {
            required: true,
            type: Number
        },

        enquiryId: {
            required: true,
            type: Number
        },

        type: {
            required: true,
            type: String
        },

        disabled: {
            required: true,
            type: Boolean
        },

        isOrder: {
            required: true,
            type: Boolean
        },

        updateStats: {
            required: true,
            type: Function
        }
    },

    data() {
        return {
            loading: true,
            currencySelectable: this.type === "dax",
            reasonSelectable: this.type !== "deposits",

            costs: [],
            reloadID: 0,

            disabledOrNoPerm:
                this.disabled ||
                !authed.permissions.includes("additional costs")
        };
    },

    computed: {
        route() {
            return "deposits" !== this.type ? this.type : "customer";
        },

        existingReasonSelectable() {
            if (this.isOrder) {
                return false;
            }

            return true;
        }
    },

    methods: {
        onModified(route, key = null, params) {
            console.log(key);

            let cost = null;
            if (null !== key) {
                cost = this.costs[key];
                params.costID = cost.ID;
            }

            params.enquiryID = this.enquiryId;

            // console.log("onModified", params, this.costs[key].ID);

            axios
                .post(route, params)
                .then(response => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.updateStats(data.calculated_stats);

                        if (null !== key) {
                            if (data.cost) {
                                data.cost.reloadID = ++this.reloadID;
                                Vue.set(this.costs, key, data.cost); // makes vue pay attention to the change
                            } else {
                                for (
                                    let idx = 0;
                                    idx < this.costs.length;
                                    idx++
                                ) {
                                    const _cost = this.costs[idx];

                                    if (_cost.ID === cost.ID) {
                                        this.costs.splice(idx, 1);

                                        return;
                                    }
                                }
                            }
                        } else {
                            this.costs.push(data.cost);
                            this.$refs.create.reset();
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                    console.error(error.response);

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                });
        },

        onSubmit(key, params) {
            this.onModified(
                "/api/enquiries/costs/" + this.route + "/submit",
                key,
                params
            );
        },

        onUpdated(key, params) {
            this.onModified(
                "/api/enquiries/costs/" + this.route + "/update",
                key,
                params
            );
        },

        onDeleted(key) {
            this.onModified(
                "/api/enquiries/costs/" + this.route + "/delete",
                key,
                {}
            );
        }
    },

    mounted() {
        // not route since list returns different for customer/deposits
        // but since deposits are just customers with reason 7
        // all the other routes are fine as customer
        axios
            .post("/api/enquiries/costs/" + this.type + "/list", {
                enquiryID: this.enquiryId
            })
            .then(response => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loading = false;
                    this.costs = data.costs;
                }
            })
            .catch(error => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    }
};
</script>
